<template>
  <div class="container mycontainer">
    <h1 class="style-h3">Les formateurs</h1>
    <p>
      L'intégralité de nos formations sont réalisées par des professionnels de
      santé experts dans les domaines abordés.
    </p>
    <div class="row">
      <div
        class="col-lg-4 col-sm-6 col-12"
        v-for="item in formateurs"
        :key="item.id"
        data-toggle="modal"
        :data-target="'#exampleModal' + item.id"
      >
        <div class="card card-formateur">
          <div class="card-body">
            <div class="card-avatar">
              <img class="rounded-circle" :src="item.image" alt="" />
              <!-- :src="item.image"-->
            </div>
            <h2 class="card-title">
              {{ item.prenom }} {{ item.nom.toUpperCase() }}
            </h2>
            <p class="card-text">{{ item.metier }}</p>
            <ul class="list-inline d-flex justify-content-center flex-wrap">
              <li class="badge badge-danger">{{ item.role }}</li>
              <li class="badge badge-primary">{{ item.expertise }}</li>
              <li class="badge badge-warning">{{ item.disciplines }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        v-for="item in formateurs"
        :key="item.id"
        class="modal fade"
        :id="'exampleModal' + item.id"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title" id="exampleModalLabel">
                Curriculum vitae
              </h3>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="d-flex align-items-start">
                <div class="modal-body-avatar">
                  <img :src="item.image" alt="" />
                </div>
                <div
                  class="modal-body-content"
                  style="
                    max-height: calc(100vh - 210px);
                    overflow-y: auto !important;
                  "
                >
                  <h4>{{ item.nom }} {{ item.prenom }}</h4>
                  <p v-html="item.cv"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created: function () {
    this.$firestore
      .collection("formateurs")
      .orderBy("nom")
      .get()

      .then((snapshot) => {
        this.formateurs = [];
        snapshot.forEach((doc) => {
          let k = doc.data();
          k["id"] = doc.id;
          this.formateurs.push(k);
        });
      })
      .catch((err) => {
        console.log("Error getting documents", err);
      });
  },
  metaInfo() {
    return {
      title:
        "Les formateurs d’OFORIS, des médecins spécialistes de leur domaine",
      meta: [
        {
          name: "description",
          content:
            "Apprenez-en plus sur notre équipe de formateurs experts, leur spécialité médicale, leur parcours, leur expérience et leurs travaux scientifiques ",
        },
        {
          property: "og:title",
          content:
            "Les formateurs d’OFORIS, des médecins spécialistes de leur domaine",
        },
        { property: "og:site_name", content: "Oforis" },
        { property: "og:type", content: "website" },
      ],
    };
  },
  data() {
    return {
      formateurs: [],
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>
<style scss>
body.is-home {
  background-image: None;
  background-size: 60%;
}
</style>